let WidgetUtils = {
    InterfaceCategory: {
        TEMPERATURE: "TEMPERATURE",
    },

    InterfaceUnits: {
        MINUTES: "MINUTES",
        SECONDS: "SECONDS",
        TIME: "TIME"
    },

    WidgetType: {
        STICKY_NOTE: "STICKY_NOTE",
        DIRECT_VALUE: "DIRECT_VALUE",
        IFRAME: "IFRAME",
        CONTROLLER: "CONTROLLER",
        COMPLEX_CHART: "COMPLEX_CHART",
        TITLE: "TITLE"
    },

    WidgetDefaultSize: {
        STICKY_NOTE: { h: 1, w: 2, minH: 1, maxH: Infinity, minW: 1, maxW: Infinity },
        DIRECT_VALUE: { h: 1, w: 3, minH: 1, maxH: 1, minW: 3, maxW: Infinity },
        IFRAME: { h: 3, w: 4, minH: 1, maxH: Infinity, minW: 3, maxW: Infinity },
        CONTROLLER: { h: 1, w: 3, minH: 1, maxH: 1, minW: 3, maxW: Infinity },
        COMPLEX_CHART: { h: 3, w: 4, minH: 3, maxH: 3, minW: 3, maxW: Infinity },
        TITLE: { h: 1, w: 2, minH: 1, maxH: 1, minW: 1, maxW: Infinity },
    },

    WidgetConfigFieldType: {
        DISPLAY_NAME: "widgetDisplayName",
        INTERFACE_SELECTOR: "interfaceSelector",
        TEXT: "text",
        URL: "widgetUrl",
        CHART_SERIES_SELECTOR: "chartSeriesSelector",
        CHECKBOX: "checkbox"
    },

    fieldConfig: {
        labeledField: {
            maxTextLength: 150
        },
    },

    TemporalUnits: [
        'MINUTES', 'SECONDS', 'TIME'
    ],

    ChartResolution: {
        FIVE_MIN : "5m",
        FIFTEEN_MIN	:"15m",
        ONE_HOUR	:"1h",
        ONE_DAY		:"1d",
        ONE_WEEK	:"1w",
        ONE_MONTH	:"1M",
        ONE_YEAR	:"1Y",
    },
};

export default WidgetUtils;